import { render, staticRenderFns } from "./PointBitcashConfirm.vue?vue&type=template&id=6a29e396"
import script from "./PointBitcashConfirm.vue?vue&type=script&lang=js"
export * from "./PointBitcashConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports